import { Button, Tooltip } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import biometric from "Assets/Icons/Biometric/biometric-outline-16px.svg";
import clock from "Assets/Icons/Clock-time/clock-time-16px.svg";
import logoutIcon from "Assets/newicons/action/logout/outline/logout-outline-16px.svg";
import attendanceIcon from "Assets/newicons/app/attendance/outline/attendance-outline-16px.svg";
import expenseoutlined from "Assets/newicons/app/expense/outline/expense-outline-16px.svg";
import holidayoutlined from "Assets/newicons/app/holiday/outline/holiday-outline-16px.svg";
import leavesoutlined from "Assets/newicons/app/leaves/outline/leaves-outline-16px.svg";
import Performreviewoutlined from "Assets/newicons/app/okr/outilne/perform-outline-16px.svg";
import policyoutlined from "Assets/newicons/document/policy/outline/policy-outline-16px.svg";
import accountingIcon from "Assets/newicons/finance/accounting/outline/accounting-outline-16px.svg";
import workflow from "Assets/newicons/office/approval-workflow/outline/approval-workflow-outline-16px.svg";
import probationIcon from "Assets/newicons/office/probation/outline/probation-outline-16px.svg";
import userIconOutline from "Assets/newicons/user/user/outline/user-outline-16px.svg";
import payrollglyph from "Assets/Svg/payroll-glyph-16-px.svg";
import IconLabel from "Component/Labels/IconLabel";
import get from "lodash/get";
import moment from "moment";
import React from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  downloadFile,
  instance,
  instanceMultipart,
} from "../../../../Actions/AxiosInstance";
// import { SaveEmployeeid } from "../../../../Actions/commonAction";
import addRoundFilledBlue from "../../../../Assets/newicons/action/add-round/glyph/add-round-filled-blue-16px.svg";
import walletIcon from "../../../../Assets/Svg/wallet.svg";
import DynamicForm from "../../../../Component/DynamicForm";
import { selectinputconverter } from "../../../../Component/DynamicForm/Fields/Select";
import DrawerHeader from "../../../../Component/Headers/drawerHeader";
import LabelIcon from "../../../../Component/Labels/LabelIcon";
import ThumbnailBig from "../../../../Component/Thumbnail/ThumbnailBig";
import { ErrorMessages } from "../../../../Constants";
import { getUrlExtension } from "../../../../Handlers/getters";
import { getFormattedImageLink } from "../../../../Utils";

class DocumentationTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      employeeid: this.props.AuthenticationAction.login.employeeid,
      attendanceleavepolicydata: [],
      generalpolicydata: [],
      payrollexpensepolicydata: [],
      performancemanagementdata: [],
      DocTypes: [],
      isapprovalWorkflow: false,
      EmpDocsReceived: [],
      received: false,
      drawerStatus: false,
      selectedDoc: "",
      selectedDocType: "",
      selectedUploadDoc: "",
      tabId: 0,
      policyTabs: [
        {
          label: "General Policy",
          icon: <img src={userIconOutline} style={{ marginBottom: 0 }}></img>,
          id: 0,
          name: "generalpolicy",
        },
        {
          label: "Attendance & Leave Policies",
          icon: <img src={policyoutlined} style={{ marginBottom: 0 }}></img>,
          id: 1,
          name: "attendanceleaves",
        },
        {
          label: "Payroll and expense policies",
          icon: <img src={policyoutlined} style={{ marginBottom: 0 }}></img>,
          id: 2,
          name: "payroll",
        },
        {
          label: "Performance management",
          icon: <img src={policyoutlined} style={{ marginBottom: 0 }}></img>,
          id: 3,
          name: "performance",
        },
      ],
    };
    this.getDocumentListComponent = this.getDocumentListComponent.bind(this);
    this.uploadDoc = this.uploadDoc.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.getEmpDocs = this.getEmpDocs.bind(this);
    this.getDocTypes = this.getDocTypes.bind(this);
    this.uploadDocComp = this.uploadDocComp.bind(this);
    this.getProfileprivacydata = this.getProfileprivacydata.bind(this);
    this.getComponent = this.getComponent.bind(this);
    // this.setActiveTab = this.setActiveTab.bind(this);
  }

  componentDidMount() {
    this.getDocTypes();
    this.getEmpDocs();
    this.getProfileprivacydata();
    // $(document).ready(() => {
    //   $("a.scrollLink").click(function (event) {
    //     event.preventDefault();
    //     $("html body").animate(
    //       { scrollTop: $($(this).attr("href")).offset().top },
    //       500,
    //     );
    //   });
    //   // $("#pd4").click(() => {
    //   //   const container = document.getElementById("col2");
    //   //   const scrollTo = document.getElementById("anchor4");
    //   //   container.scrollTop = scrollTo.offsetTop;
    //   // });
    // });
  }

  getProfileprivacydata() {
    // const employeeid = this.props.AuthenticationAction.login.employeeid;
    const employeeid =
      get(this.props, "colleagueid", "") ||
      get(this.props, "AuthenticationAction.login.employeeid", "");
    const URL = `employee/emppolicy/${employeeid}`;
    instance
      .get(URL)
      .then((res) => {
        this.setState({
          attendanceleavepolicydata: res.data.result[0].attendanceleavepolicy,
          generalpolicydata: res.data.result[0].generalpolicy,
          payrollexpensepolicydata: res.data.result[0].payrollexpensepolicy,
          performancemanagementdata: res.data.result[0].perform,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getEmpDocs() {
    const URL = "employee/getemployeefile";
    const DATA = {};
    if (this.props.colleagueid) {
      DATA.employeeid = this.props.colleagueid;
    }
    instance
      .post(URL, DATA)
      .then((result) => {
        this.setState({
          EmpDocsReceived: result.data.result,
          received: true,
          selectedDoc: "",
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getDocTypes() {
    const URL = "subscription/countryfiletag";
    instance
      .get(URL)
      .then((res) => {
        this.setState({
          DocTypes: [...res.data.result],
        });
      })
      .catch(() => {
        this.setState({
          DocTypes: [{ displayname: "Select", displayvalue: null }],
        });
      });
  }

  removeFile(docDetails) {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="1"
          color="inherit"
          size="small"
          onClick={() => {
            const data = {
              employeefileid: [docDetails.employeefileid],
            };
            instance
              .post("employee/deleteemployeefile", data)
              .then(() => {
                this.getEmpDocs();
                this.props.enqueueSnackbar("Deleted successfully", {
                  variant: "success",
                });
              })
              .catch((error) => {
                const CommonError = error.response
                  ? error.response.data.error.message
                  : error.message;
                this.props.enqueueSnackbar(CommonError, { variant: "error" });
              });
          }}
        >
          Yes
        </Button>,
        <Button key="2" color="inherit" size="small">
          No
        </Button>,
      ],
    });
  }

  uploadDoc(files) {
    const file = files[0];
    let extFile;
    if (file) {
      const img = file.name.split(";");
      const imgname = img[0];
      extFile = getUrlExtension(imgname);
      // let idxDot;
      // idxDot = imgname.lastIndexOf(".") + 1;
      // extFile = imgname.substr(idxDot, imgname.length).toLowerCase();
    }
    const availableExt = [
      "png",
      "jpg",
      "jpeg",
      "pdf",
      "ppt",
      "pptx",
      "doc",
      "docx",
      "txt",
      "odt",
    ];
    if (availableExt.findIndex((x) => extFile == x) == -1) {
      this.props.enqueueSnackbar("Please upload image or pdf only", {
        variant: "error",
      });
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    const URL = "employee/uploademployeefiles";
    instanceMultipart.post(URL, formData).then((resp) => {
      const fileMetaData = resp.data.result[0];
      this.setState({ selectedUploadDoc: fileMetaData });
    });
  }

  onSave = () => {
    const { selectedUploadDoc, selectedDocType, DocTypes } = this.state;
    const fileMetaData = selectedUploadDoc;
    if (!fileMetaData || !selectedDocType) {
      this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
    }
    const filename = DocTypes.find((x) => x.displayvalue == selectedDocType);
    const data = {
      employeeid:
        get(this.props, "colleagueid", "") ||
        get(this.props, "AuthenticationAction.login.employeeid", ""),
      filedata: {
        filedata: [
          {
            employeefileid:
              get(this.props, "colleagueid", "") ||
              get(this.state, "AuthenticationAction.login.employeeid", null),
            filename: filename ? filename.displayvalue : "",
            originalfilename: fileMetaData.originalname,
            fileextension: fileMetaData.extension,
            filesize: fileMetaData.size,
            filepath: fileMetaData.imagepath,
            filetagtypeid: selectedDocType,
            filefortypeid: 1,
          },
        ],
      },
    };
    instance.post("employee/insertupdateemployeefile", data).then((resp) => {
      this.setState(
        { selectedDocType: "", selectedUploadDoc: "", drawerStatus: false },
        () => this.getEmpDocs(),
      );
    });
  };

  downloadDoc = (path) => {
    downloadFile(path);
  };

  getDocumentListComponent() {
    const { EmpDocsReceived = [] } = this.state;
    return (
      <div>
        <div
          className="cursour-pointer"
          onClick={() => this.setState({ drawerStatus: true })}
        >
          <img src={addRoundFilledBlue} className="vertical-middle" />
          <span className="small-blue t-bold margin-left-8">
            Add new document
          </span>
        </div>
        <br />
        {EmpDocsReceived.map((doc) => {
          const cls =
            doc.employeefileid ==
            get(this.state, "selectedDoc.employeefileid", "")
              ? "text-color-blue"
              : "";
          return (
            <div
              key="key"
              className={`${cls} cursour-pointer margin-left-10 margin-top-20`}
              onClick={() => this.setState({ selectedDoc: doc })}
            >
              <LabelIcon
                label={
                  doc.filetagtypeid == 99
                    ? doc.originalfilename
                    : doc.filetagname
                }
                img={walletIcon}
                labelClassNames={cls}
              />
            </div>
          );
        })}
      </div>
    );
  }

  // onEditDoc = () => {
  //   document.getElementById("fileupload").click();
  // };

  uploadDocEdit = (e) => {
    if (get(e, "target.files[0]", "")) {
      const _file = e.target.files[0];
      this.uploadDoc([_file]);
    }
  };

  onDeleteDoc = () => {
    this.setState({ selectedUploadDoc: "" });
  };

  uploadDocComp() {
    const {
      DocTypes,
      selectedDocType,
      selectedUploadDoc,
      EmpDocsReceived = [],
    } = this.state;

    return (
      <div className="planner-right-drawer">
        {/* <span
          onClick={() => this.setState({ drawerStatus: false })}
          className="drawer-close-btn margin-bottom-14 margin-top-4"
        >
          <img src={cancelIcon} />
        </span>
        <span className="drawer-header  margin-bottom-14">Upload new document</span> */}

        <DrawerHeader
          header="Upload new document"
          isbackarrow={false}
          closeDrawer={() => this.setState({ drawerStatus: false })}
        />

        <DynamicForm
          className="margin-20 margin-top-20"
          fields={selectinputconverter({
            options: DocTypes.filter(
              (x) =>
                EmpDocsReceived.findIndex(
                  (y) => y.filetagtypeid == x.displayvalue,
                ) == -1 || x.displayvalue == 99,
            ),
            value: selectedDocType,
            label: "Document type",
            placeholder: "Select tag for this document",
          })}
          onChange={(val) => this.setState({ selectedDocType: val })}
        />
        <br />
        <Grid container>
          {selectedUploadDoc ? (
            <Grid md="12">
              {/* <input id="fileupload" type="file" name="Upload Emploxyee Data" onChange={(e) => this.uploadDocEdit(e)} hidden /> */}
              <ThumbnailBig
                key="key"
                onDelete={this.onDeleteDoc}
                onEdit={this.uploadDoc}
                filetypes="image/*,.pdf,.ppt,.pptx,.doc,.docx,.txt,.odt"
                doc={{
                  url: getFormattedImageLink(selectedUploadDoc.imagepath),
                }}
              />
            </Grid>
          ) : (
            <Tooltip title="Add attachment" placement="right">
              <Dropzone
                onDrop={(e) => this.uploadDoc(e)}
                multiple={false}
                accept="image/*,.pdf,.ppt,.pptx,.doc,.docx,.txt,.odt"
                maxSize={2000000}
                className="drag-drop"
              >
                <Grid md="12">
                  <div className="add-attachment-new">
                    <img src={addRoundFilledBlue}></img>
                  </div>
                </Grid>
              </Dropzone>
            </Tooltip>
          )}

          <br />
          <p className="input-label" >
              Note: Upload photo with max size 2 MB for optimum results.
              (Supports .gif, .jpeg, .jpg, .png, .pdf, .ppt, .pptx, .doc, .docx, .txt and .odt file types)
          </p>
          <Grid md="12">
            <Button
              className="btn btn-primary-sm-blue margin-top-20"
              onClick={this.onSave}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }

  getComponent(key) {
    // this.props.SaveEmployeeid(this.state.employeeid);
    const employeeid =
      get(this.props, "colleagueid", "") ||
      get(this.props, "AuthenticationAction.login.employeeid", "");
    localStorage.setItem("tempempid", employeeid);

    if (key == "approvalworkflow") {
      const employeeLink = `${window.location.origin}/live_data/approval_workflow`;
      window.open(employeeLink, "_blank");
    } else if (key == "exitpolicy") {
      const employeeLink = `${window.location.origin}/live_data/exitpolicy`;
      window.open(employeeLink, "_blank");
    } else if (key == "probationplanner") {
      const employeeLink = `${window.location.origin}/planner/probationplanner`;
      window.open(employeeLink, "_blank");
    } else if (key == "permissionpolicy") {
      const employeeLink = `${window.location.origin}/live_data/permissionpolicy`;
      window.open(employeeLink, "_blank");
    } else if (key == "shiftplanner") {
      const employeeLink = `${window.location.origin}/planner/shiftplanner`;
      window.open(employeeLink, "_blank");
    } else if (key == "devicepolicy") {
      const employeeLink = `${window.location.origin}/live_data/employee_device_mapping`;
      window.open(employeeLink, "_blank");
    } else if (key == "attendancepolicy") {
      const employeeLink = `${window.location.origin}/live_data/employee_device_mapping`;
      window.open(employeeLink, "_blank");
    } else if (key == "extratimeplanner") {
      const employeeLink = `${window.location.origin}/planner/extratimeplanner`;
      window.open(employeeLink, "_blank");
    } else if (key == "weeklyoff") {
      const employeeLink = `${window.location.origin}/planner/extratimeplanner`;
      window.open(employeeLink, "_blank");
    } else if (key == "holidayplanner") {
      const employeeLink = `${window.location.origin}/planner/holidayplanner`;
      window.open(employeeLink, "_blank");
    } else if (key == "leavepolicyplanner") {
      const employeeLink = `${window.location.origin}/planner/leavepolicyplanner`;
      window.open(employeeLink, "_blank");
    } else if (key == "expensepolicy") {
      const employeeLink = `${window.location.origin}/live_data/expensepolicy`;
      window.open(employeeLink, "_blank");
    } else if (key == "salarystructure") {
      const employeeLink = `${window.location.origin}/live_data/salary_structure`;
      window.open(employeeLink, "_blank");
    } else if (key == "fbp") {
      const employeeLink = `${window.location.origin}/planner/payroll`;
      window.open(employeeLink, "_blank");
    } else if (key == "fnf") {
      const employeeLink = `${window.location.origin}/live_data/fnf`;
      window.open(employeeLink, "_blank");
    }
  }

  render() {
    const {
      attendanceleavepolicydata,
      generalpolicydata,
      payrollexpensepolicydata,
      performancemanagementdata,
    } = this.state;

    return (
      <Grid container>
        <Grid
          item
          xs={12}
          md={3}
          sm={3}
          className="padding-top-30 position-rel"
          style={{ padding: 16 }}
        >
          <a href="#anchor1" id="pd1" className="scrollLink">
            <div tabIndex="0" style={{ padding: "14px 0px", display: "flex" }}>
              <img src={policyoutlined}></img>
              <p className="small-dark-secondary margin-left-8">
                General Policy
              </p>
            </div>
          </a>
          <a href="#anchor2" className="scrollLink">
            <div tabIndex="1" style={{ padding: "14px 0px", display: "flex" }}>
              <img src={attendanceIcon}></img>
              <p className="small-dark-secondary margin-left-8">
                {" "}
                Attendance & Leave Policies
              </p>
            </div>
          </a>
          <a href="#anchor3" className="scrollLink">
            <div tabIndex="2" style={{ padding: "14px 0px", display: "flex" }}>
              <img src={payrollglyph}></img>
              <p className="small-dark-secondary margin-left-8">
                {" "}
                Payroll & expense policies
              </p>
            </div>
          </a>
          <a href="#anchor4" id="pd4" className="scrollLink">
            <div tabIndex="3" style={{ padding: "14px 0px", display: "flex" }}>
              <img src={Performreviewoutlined}></img>
              <p className="small-dark-secondary margin-left-8">
                {" "}
                Performance management
              </p>
            </div>
          </a>
          <div
            style={{
              width: 4,
              height: "100%",
              background: "rgb(211, 211, 211)",
              position: "absolute",
              zIndex: -1,
              top: 0,
              right: 0,
            }}
          ></div>
        </Grid>
        <Grid item xs={12} md={9} sm={9}>
          <div id="col2" style={{ padding: "0px 32px" }}>
            <div
              id="anchor1"
              className="inner-wrapper translucent "
              tabIndex="0"
            >
              <p className="normal-drak-secondary t-bold margin-bottom-16">
                General
              </p>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Approval Workflow"
                    img={workflow}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {generalpolicydata.approvalworkflowpolicy &&
                  generalpolicydata.approvalworkflowpolicy.length > 0 &&
                  generalpolicydata.approvalworkflowpolicy[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {generalpolicydata.approvalworkflowpolicy[0] &&
                        generalpolicydata.approvalworkflowpolicy[0].date}{" "}
                      By{" "}
                      {generalpolicydata.approvalworkflowpolicy[0] &&
                        generalpolicydata.approvalworkflowpolicy[0].assignedby}
                    </p>
                  ) : (
                    ""
                  )}
                </div>

                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {generalpolicydata.approvalworkflowpolicy &&
                    generalpolicydata.approvalworkflowpolicy.length > 0 &&
                    generalpolicydata.approvalworkflowpolicy[0] &&
                    generalpolicydata.approvalworkflowpolicy[0]
                      .approvalworkflowpolicyname
                      ? generalpolicydata.approvalworkflowpolicy[0]
                          .approvalworkflowpolicyname
                      : "Not assigned"}
                  </p>

                  <Button
                    variant="contained"
                    className={
                      generalpolicydata.approvalworkflowpolicy &&
                      generalpolicydata.approvalworkflowpolicy.length > 0 &&
                      generalpolicydata.approvalworkflowpolicy[0] &&
                      generalpolicydata.approvalworkflowpolicy[0]
                        .approvalworkflowpolicyname
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => {
                      this.getComponent("approvalworkflow");
                    }}
                  >
                    {generalpolicydata.approvalworkflowpolicy &&
                    generalpolicydata.approvalworkflowpolicy.length > 0 &&
                    generalpolicydata.approvalworkflowpolicy[0] &&
                    generalpolicydata.approvalworkflowpolicy[0]
                      .approvalworkflowpolicyname
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Exit Policy"
                    img={logoutIcon}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {generalpolicydata.exitpolicy &&
                  generalpolicydata.exitpolicy.length > 0 &&
                  generalpolicydata.exitpolicy[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {generalpolicydata.exitpolicy &&
                        generalpolicydata.exitpolicy.length > 0 &&
                        generalpolicydata.exitpolicy[0] &&
                        generalpolicydata.exitpolicy[0].date}{" "}
                      By{" "}
                      {generalpolicydata.exitpolicy &&
                        generalpolicydata.exitpolicy.length > 0 &&
                        generalpolicydata.exitpolicy[0] &&
                        generalpolicydata.exitpolicy[0].assignedby}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {generalpolicydata.exitpolicy &&
                    generalpolicydata.exitpolicy.length > 0 &&
                    generalpolicydata.exitpolicy[0] &&
                    generalpolicydata.exitpolicy[0].policyname
                      ? generalpolicydata.exitpolicy[0].policyname
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      generalpolicydata.exitpolicy &&
                      generalpolicydata.exitpolicy.length > 0 &&
                      generalpolicydata.exitpolicy[0] &&
                      generalpolicydata.exitpolicy[0].policyname
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    //  onClick={() => this.getComponent("exitpolicy")}
                    onClick={() => {
                      this.getComponent("exitpolicy");
                    }}
                  >
                    {generalpolicydata.exitpolicy &&
                    generalpolicydata.exitpolicy.length > 0 &&
                    generalpolicydata.exitpolicy[0] &&
                    generalpolicydata.exitpolicy[0].policyname
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Probation"
                    img={probationIcon}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {generalpolicydata.probationpolicy &&
                  generalpolicydata.probationpolicy.length > 0 &&
                  generalpolicydata.probationpolicy[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {generalpolicydata.probationpolicy &&
                        generalpolicydata.probationpolicy.length > 0 &&
                        generalpolicydata.probationpolicy[0] &&
                        generalpolicydata.probationpolicy[0].date}{" "}
                      By{" "}
                      {generalpolicydata.probationpolicy &&
                        generalpolicydata.probationpolicy.length > 0 &&
                        generalpolicydata.probationpolicy[0] &&
                        generalpolicydata.probationpolicy[0].assignedby}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {generalpolicydata.probationpolicy &&
                    generalpolicydata.probationpolicy.length > 0 &&
                    generalpolicydata.probationpolicy[0] &&
                    generalpolicydata.probationpolicy[0].probationperiodname
                      ? generalpolicydata.probationpolicy[0].probationperiodname
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      generalpolicydata.probationpolicy &&
                      generalpolicydata.probationpolicy.length > 0 &&
                      generalpolicydata.probationpolicy[0] &&
                      generalpolicydata.probationpolicy[0].probationperiodname
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => this.getComponent("probationplanner")}
                  >
                    {generalpolicydata.probationpolicy &&
                    generalpolicydata.probationpolicy.length > 0 &&
                    generalpolicydata.probationpolicy[0] &&
                    generalpolicydata.probationpolicy[0].probationperiodname
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Permission policy"
                    img={probationIcon}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {generalpolicydata.permissionpolicy &&
                  generalpolicydata.permissionpolicy.length > 0 &&
                  generalpolicydata.permissionpolicy[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {generalpolicydata.permissionpolicy &&
                        generalpolicydata.permissionpolicy.length > 0 &&
                        generalpolicydata.permissionpolicy[0] &&
                        moment(
                          generalpolicydata.permissionpolicy[0].date,
                        ).format("YYYY-MM-DD")}{" "}
                      By{" "}
                      {generalpolicydata.permissionpolicy &&
                        generalpolicydata.permissionpolicy.length > 0 &&
                        generalpolicydata.permissionpolicy[0] &&
                        generalpolicydata.permissionpolicy[0].assignedby}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {generalpolicydata.permissionpolicy &&
                    generalpolicydata.permissionpolicy.length > 0 &&
                    generalpolicydata.permissionpolicy[0] &&
                    generalpolicydata.permissionpolicy[0].profilename
                      ? generalpolicydata.permissionpolicy[0].profilename
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      generalpolicydata.permissionpolicy &&
                      generalpolicydata.permissionpolicy.length > 0 &&
                      generalpolicydata.permissionpolicy[0] &&
                      generalpolicydata.permissionpolicy[0].profilename
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => this.getComponent("permissionpolicy")}
                  >
                    {generalpolicydata.permissionpolicy &&
                    generalpolicydata.permissionpolicy.length > 0 &&
                    generalpolicydata.permissionpolicy[0] &&
                    generalpolicydata.permissionpolicy[0].profilename
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>
            </div>
            <div
              id="anchor2"
              className="inner-wrapper translucent "
              tabIndex="1"
            >
              <p className="normal-drak-secondary t-bold margin-bottom-16">
                Attendance & Leave
              </p>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Shift"
                    img={clock}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {attendanceleavepolicydata.shiftpolicy &&
                  attendanceleavepolicydata.shiftpolicy.length > 0 &&
                  attendanceleavepolicydata.shiftpolicy[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {attendanceleavepolicydata.shiftpolicy &&
                        attendanceleavepolicydata.shiftpolicy.length > 0 &&
                        attendanceleavepolicydata.shiftpolicy[0] &&
                        attendanceleavepolicydata.shiftpolicy[0].date}{" "}
                      By{" "}
                      {attendanceleavepolicydata.shiftpolicy &&
                        attendanceleavepolicydata.shiftpolicy.length > 0 &&
                        attendanceleavepolicydata.shiftpolicy[0] &&
                        attendanceleavepolicydata.shiftpolicy[0].assignedby}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {attendanceleavepolicydata.shiftpolicy &&
                    attendanceleavepolicydata.shiftpolicy.length > 0 &&
                    attendanceleavepolicydata.shiftpolicy[0] &&
                    attendanceleavepolicydata.shiftpolicy[0].shiftname
                      ? attendanceleavepolicydata.shiftpolicy[0].shiftname
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      attendanceleavepolicydata.shiftpolicy &&
                      attendanceleavepolicydata.shiftpolicy.length > 0 &&
                      attendanceleavepolicydata.shiftpolicy[0] &&
                      attendanceleavepolicydata.shiftpolicy[0].shiftname
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => this.getComponent("shiftplanner")}
                  >
                    {attendanceleavepolicydata.shiftpolicy &&
                    attendanceleavepolicydata.shiftpolicy.length > 0 &&
                    attendanceleavepolicydata.shiftpolicy[0] &&
                    attendanceleavepolicydata.shiftpolicy[0].shiftname
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Clockin Method"
                    img={biometric}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {attendanceleavepolicydata.devicepolicy &&
                  attendanceleavepolicydata.devicepolicy.length > 0 &&
                  attendanceleavepolicydata.devicepolicy[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {attendanceleavepolicydata.devicepolicy &&
                        attendanceleavepolicydata.devicepolicy.length > 0 &&
                        attendanceleavepolicydata.devicepolicy[0] &&
                        attendanceleavepolicydata.devicepolicy[0].date}{" "}
                      By{" "}
                      {attendanceleavepolicydata.devicepolicy &&
                        attendanceleavepolicydata.devicepolicy.length > 0 &&
                        attendanceleavepolicydata.devicepolicy[0] &&
                        attendanceleavepolicydata.devicepolicy[0].assignedby}
                    </p>
                  ) : (
                    " "
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {attendanceleavepolicydata.devicepolicy &&
                    attendanceleavepolicydata.devicepolicy.length > 0 &&
                    attendanceleavepolicydata.devicepolicy[0] &&
                    attendanceleavepolicydata.devicepolicy[0].devicepolicyname
                      ? attendanceleavepolicydata.devicepolicy[0]
                          .devicepolicyname
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      attendanceleavepolicydata.devicepolicy &&
                      attendanceleavepolicydata.devicepolicy.length > 0 &&
                      attendanceleavepolicydata.devicepolicy[0] &&
                      attendanceleavepolicydata.devicepolicy[0].devicepolicyname
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => this.getComponent("shiftplanner")}
                  >
                    {attendanceleavepolicydata.devicepolicy &&
                    attendanceleavepolicydata.devicepolicy.length > 0 &&
                    attendanceleavepolicydata.devicepolicy[0] &&
                    attendanceleavepolicydata.devicepolicy[0].devicepolicyname
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Attendance Policy"
                    img={attendanceIcon}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {attendanceleavepolicydata.attendancepolicy &&
                  attendanceleavepolicydata.attendancepolicy.length > 0 &&
                  attendanceleavepolicydata.attendancepolicy[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {attendanceleavepolicydata.attendancepolicy &&
                        attendanceleavepolicydata.attendancepolicy.length > 0 &&
                        attendanceleavepolicydata.attendancepolicy[0] &&
                        attendanceleavepolicydata.attendancepolicy[0].date}{" "}
                      By{" "}
                      {attendanceleavepolicydata.attendancepolicy &&
                        attendanceleavepolicydata.attendancepolicy.length > 0 &&
                        attendanceleavepolicydata.attendancepolicy[0] &&
                        attendanceleavepolicydata.attendancepolicy[0]
                          .assignedby}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {attendanceleavepolicydata.attendancepolicy &&
                    attendanceleavepolicydata.attendancepolicy.length > 0 &&
                    attendanceleavepolicydata.attendancepolicy[0] &&
                    attendanceleavepolicydata.attendancepolicy[0]
                      .attendancepolicyname
                      ? attendanceleavepolicydata.attendancepolicy[0]
                          .attendancepolicyname
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      attendanceleavepolicydata.attendancepolicy &&
                      attendanceleavepolicydata.attendancepolicy.length > 0 &&
                      attendanceleavepolicydata.attendancepolicy[0] &&
                      attendanceleavepolicydata.attendancepolicy[0]
                        .attendancepolicyname
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => this.getComponent("shiftplanner")}
                  >
                    {attendanceleavepolicydata.attendancepolicy &&
                    attendanceleavepolicydata.attendancepolicy.length > 0 &&
                    attendanceleavepolicydata.attendancepolicy[0] &&
                    attendanceleavepolicydata.attendancepolicy[0]
                      .attendancepolicyname
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Extra Time"
                    img={clock}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {attendanceleavepolicydata.extratimepolicy &&
                  attendanceleavepolicydata.extratimepolicy.length > 0 &&
                  attendanceleavepolicydata.extratimepolicy[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {attendanceleavepolicydata.extratimepolicy &&
                        attendanceleavepolicydata.extratimepolicy.length > 0 &&
                        attendanceleavepolicydata.extratimepolicy[0] &&
                        attendanceleavepolicydata.extratimepolicy[0].date}{" "}
                      By{" "}
                      {attendanceleavepolicydata.extratimepolicy &&
                        attendanceleavepolicydata.extratimepolicy.length > 0 &&
                        attendanceleavepolicydata.extratimepolicy[0] &&
                        attendanceleavepolicydata.extratimepolicy[0].assignedby}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {attendanceleavepolicydata.extratimepolicy &&
                    attendanceleavepolicydata.extratimepolicy.length > 0 &&
                    attendanceleavepolicydata.extratimepolicy[0] &&
                    attendanceleavepolicydata.extratimepolicy[0]
                      .extratimepolicyname
                      ? attendanceleavepolicydata.extratimepolicy[0]
                          .extratimepolicyname
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      attendanceleavepolicydata.extratimepolicy &&
                      attendanceleavepolicydata.extratimepolicy.length > 0 &&
                      attendanceleavepolicydata.extratimepolicy[0] &&
                      attendanceleavepolicydata.extratimepolicy[0]
                        .extratimepolicyname
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => this.getComponent("extratimeplanner")}
                  >
                    {attendanceleavepolicydata.extratimepolicy &&
                    attendanceleavepolicydata.extratimepolicy.length > 0 &&
                    attendanceleavepolicydata.extratimepolicy[0] &&
                    attendanceleavepolicydata.extratimepolicy[0]
                      .extratimepolicyname
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Weekly Off"
                    img={leavesoutlined}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {attendanceleavepolicydata.weekoffpolicy &&
                  attendanceleavepolicydata.weekoffpolicy.length > 0 &&
                  attendanceleavepolicydata.weekoffpolicy[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {attendanceleavepolicydata.weekoffpolicy[0].date} By{" "}
                      {attendanceleavepolicydata.weekoffpolicy[0].assignedby}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {attendanceleavepolicydata.weekoffpolicy &&
                    attendanceleavepolicydata.weekoffpolicy.length > 0 &&
                    attendanceleavepolicydata.weekoffpolicy[0] &&
                    attendanceleavepolicydata.weekoffpolicy[0].weekoffpolicyname
                      ? attendanceleavepolicydata.weekoffpolicy[0]
                          .weekoffpolicyname
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      attendanceleavepolicydata.weekoffpolicy &&
                      attendanceleavepolicydata.weekoffpolicy.length > 0 &&
                      attendanceleavepolicydata.weekoffpolicy[0] &&
                      attendanceleavepolicydata.weekoffpolicy[0]
                        .weekoffpolicyname
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => this.getComponent("shiftplanner")}
                  >
                    {attendanceleavepolicydata.weekoffpolicy &&
                    attendanceleavepolicydata.weekoffpolicy.length > 0 &&
                    attendanceleavepolicydata.weekoffpolicy[0] &&
                    attendanceleavepolicydata.weekoffpolicy[0].weekoffpolicyname
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Holiday Plan"
                    img={holidayoutlined}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {attendanceleavepolicydata.holidayplan &&
                  attendanceleavepolicydata.holidayplan.length > 0 &&
                  attendanceleavepolicydata.holidayplan[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {attendanceleavepolicydata.holidayplan &&
                        attendanceleavepolicydata.holidayplan.length > 0 &&
                        attendanceleavepolicydata.holidayplan[0] &&
                        attendanceleavepolicydata.holidayplan[0].date}{" "}
                      By{" "}
                      {attendanceleavepolicydata.holidayplan &&
                        attendanceleavepolicydata.holidayplan.length > 0 &&
                        attendanceleavepolicydata.holidayplan[0] &&
                        attendanceleavepolicydata.holidayplan[0].assignedby}
                    </p>
                  ) : (
                    " "
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {attendanceleavepolicydata.holidayplan &&
                    attendanceleavepolicydata.holidayplan.length > 0 &&
                    attendanceleavepolicydata.holidayplan[0] &&
                    attendanceleavepolicydata.holidayplan[0].holidayplanname
                      ? attendanceleavepolicydata.holidayplan[0].holidayplanname
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      attendanceleavepolicydata.holidayplan &&
                      attendanceleavepolicydata.holidayplan.length > 0 &&
                      attendanceleavepolicydata.holidayplan[0] &&
                      attendanceleavepolicydata.holidayplan[0].holidayplanname
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => this.getComponent("holidayplanner")}
                  >
                    {attendanceleavepolicydata.holidayplan &&
                    attendanceleavepolicydata.holidayplan.length > 0 &&
                    attendanceleavepolicydata.holidayplan[0] &&
                    attendanceleavepolicydata.holidayplan[0].holidayplanname
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Leave Policy"
                    img={leavesoutlined}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {attendanceleavepolicydata.leavepolicy &&
                  attendanceleavepolicydata.leavepolicy.length > 0 &&
                  attendanceleavepolicydata.leavepolicy[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {attendanceleavepolicydata.leavepolicy &&
                        attendanceleavepolicydata.leavepolicy.length > 0 &&
                        attendanceleavepolicydata.leavepolicy[0] &&
                        attendanceleavepolicydata.leavepolicy[0].date}{" "}
                      By{" "}
                      {attendanceleavepolicydata.leavepolicy &&
                        attendanceleavepolicydata.leavepolicy.length > 0 &&
                        attendanceleavepolicydata.leavepolicy[0] &&
                        attendanceleavepolicydata.leavepolicy[0].assignedby}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {attendanceleavepolicydata.leavepolicy &&
                    attendanceleavepolicydata.leavepolicy.length > 0 &&
                    attendanceleavepolicydata.leavepolicy[0] &&
                    attendanceleavepolicydata.leavepolicy[0].leavepolicyname
                      ? attendanceleavepolicydata.leavepolicy[0].leavepolicyname
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      attendanceleavepolicydata.leavepolicy &&
                      attendanceleavepolicydata.leavepolicy.length > 0 &&
                      attendanceleavepolicydata.leavepolicy[0] &&
                      attendanceleavepolicydata.leavepolicy[0].leavepolicyname
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => this.getComponent("leavepolicyplanner")}
                  >
                    {attendanceleavepolicydata.leavepolicy &&
                    attendanceleavepolicydata.leavepolicy.length > 0 &&
                    attendanceleavepolicydata.leavepolicy[0] &&
                    attendanceleavepolicydata.leavepolicy[0].leavepolicyname
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>
            </div>
            <div
              id="anchor3"
              className="inner-wrapper translucent "
              tabIndex="2"
            >
              <p className="normal-drak-secondary t-bold margin-bottom-16">
                Payroll & expense
              </p>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Expense Policy"
                    img={expenseoutlined}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {payrollexpensepolicydata.expensepolicy &&
                  payrollexpensepolicydata.expensepolicy.length > 0 &&
                  payrollexpensepolicydata.expensepolicy[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {payrollexpensepolicydata.expensepolicy &&
                        payrollexpensepolicydata.expensepolicy.length > 0 &&
                        payrollexpensepolicydata.expensepolicy[0] &&
                        payrollexpensepolicydata.expensepolicy[0].date}{" "}
                      By{" "}
                      {payrollexpensepolicydata.expensepolicy &&
                        payrollexpensepolicydata.expensepolicy.length > 0 &&
                        payrollexpensepolicydata.expensepolicy[0] &&
                        payrollexpensepolicydata.expensepolicy[0].assignedby}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {payrollexpensepolicydata.expensepolicy &&
                    payrollexpensepolicydata.expensepolicy.length > 0 &&
                    payrollexpensepolicydata.expensepolicy[0] &&
                    payrollexpensepolicydata.expensepolicy[0].policyname
                      ? payrollexpensepolicydata.expensepolicy[0].policyname
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      payrollexpensepolicydata.expensepolicy &&
                      payrollexpensepolicydata.expensepolicy.length > 0 &&
                      payrollexpensepolicydata.expensepolicy[0] &&
                      payrollexpensepolicydata.expensepolicy[0].policyname
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => this.getComponent("expensepolicy")}
                  >
                    {payrollexpensepolicydata.expensepolicy &&
                    payrollexpensepolicydata.expensepolicy.length > 0 &&
                    payrollexpensepolicydata.expensepolicy[0] &&
                    payrollexpensepolicydata.expensepolicy[0].policyname
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Salary Structure"
                    img={payrollglyph}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {payrollexpensepolicydata.salarystructure &&
                  payrollexpensepolicydata.salarystructure.length > 0 &&
                  payrollexpensepolicydata.salarystructure[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {payrollexpensepolicydata.salarystructure &&
                        payrollexpensepolicydata.salarystructure.length > 0 &&
                        payrollexpensepolicydata.salarystructure[0] &&
                        payrollexpensepolicydata.salarystructure[0].date}{" "}
                      By{" "}
                      {payrollexpensepolicydata.salarystructure &&
                        payrollexpensepolicydata.salarystructure.length > 0 &&
                        payrollexpensepolicydata.salarystructure[0] &&
                        payrollexpensepolicydata.salarystructure[0].assignedby}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {payrollexpensepolicydata.salarystructure &&
                    payrollexpensepolicydata.salarystructure.length > 0 &&
                    payrollexpensepolicydata.salarystructure[0] &&
                    payrollexpensepolicydata.salarystructure[0].structurename
                      ? payrollexpensepolicydata.salarystructure[0]
                          .structurename
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      payrollexpensepolicydata.salarystructure &&
                      payrollexpensepolicydata.salarystructure.length > 0 &&
                      payrollexpensepolicydata.salarystructure[0] &&
                      payrollexpensepolicydata.salarystructure[0].structurename
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => this.getComponent("salarystructure")}
                  >
                    {payrollexpensepolicydata.salarystructure &&
                    payrollexpensepolicydata.salarystructure.length > 0 &&
                    payrollexpensepolicydata.salarystructure[0] &&
                    payrollexpensepolicydata.salarystructure[0].structurename
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="Flexible Benefit Plan"
                    img={payrollglyph}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {payrollexpensepolicydata.fbppolicy &&
                  payrollexpensepolicydata.fbppolicy.length > 0 &&
                  payrollexpensepolicydata.fbppolicy[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {payrollexpensepolicydata.fbppolicy &&
                        payrollexpensepolicydata.fbppolicy.length > 0 &&
                        payrollexpensepolicydata.fbppolicy[0] &&
                        payrollexpensepolicydata.fbppolicy[0].date}{" "}
                      By{" "}
                      {payrollexpensepolicydata.fbppolicy &&
                        payrollexpensepolicydata.fbppolicy.length > 0 &&
                        payrollexpensepolicydata.fbppolicy[0] &&
                        payrollexpensepolicydata.fbppolicy[0].assignedby}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {payrollexpensepolicydata.fbppolicy &&
                    payrollexpensepolicydata.fbppolicy.length > 0 &&
                    payrollexpensepolicydata.fbppolicy[0] &&
                    payrollexpensepolicydata.fbppolicy[0].fbpname
                      ? payrollexpensepolicydata.fbppolicy[0] &&
                        payrollexpensepolicydata.fbppolicy[0].fbpname
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      payrollexpensepolicydata.fbppolicy &&
                      payrollexpensepolicydata.fbppolicy.length > 0 &&
                      payrollexpensepolicydata.fbppolicy[0] &&
                      payrollexpensepolicydata.fbppolicy[0].fbpname
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => this.getComponent("salarystructure")}
                  >
                    {payrollexpensepolicydata.fbppolicy &&
                    payrollexpensepolicydata.fbppolicy.length > 0 &&
                    payrollexpensepolicydata.fbppolicy[0] &&
                    payrollexpensepolicydata.fbppolicy[0].fbpname
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>

              <div>
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <IconLabel
                    label="FNF Policy"
                    img={accountingIcon}
                    labelClassNames="small-blue ellipsis"
                    iconHeight="16"
                  />
                  {payrollexpensepolicydata.fnfpolicy &&
                  payrollexpensepolicydata.fnfpolicy.length > 0 &&
                  payrollexpensepolicydata.fnfpolicy[0] ? (
                    <p
                      className="small-dark-secondary"
                      style={{ fontSize: 11 }}
                    >
                      Updated On{" "}
                      {payrollexpensepolicydata.fnfpolicy &&
                        payrollexpensepolicydata.fnfpolicy.length > 0 &&
                        payrollexpensepolicydata.fnfpolicy[0] &&
                        payrollexpensepolicydata.fnfpolicy[0].date}{" "}
                      By{" "}
                      {payrollexpensepolicydata.fnfpolicy &&
                        payrollexpensepolicydata.fnfpolicy.length > 0 &&
                        payrollexpensepolicydata.fnfpolicy[0] &&
                        payrollexpensepolicydata.fnfpolicy[0].assignedby}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "none",
                  }}
                >
                  <p className="small-dark-secondary">
                    {payrollexpensepolicydata.fnfpolicy &&
                    payrollexpensepolicydata.fnfpolicy.length > 0 &&
                    payrollexpensepolicydata.fnfpolicy[0] &&
                    payrollexpensepolicydata.fnfpolicy[0].fnfpolicyname
                      ? payrollexpensepolicydata.fnfpolicy[0].fnfpolicyname
                      : "Not assigned"}
                  </p>
                  <Button
                    variant="contained"
                    className={
                      payrollexpensepolicydata.fnfpolicy &&
                      payrollexpensepolicydata.fnfpolicy.length > 0 &&
                      payrollexpensepolicydata.fnfpolicy[0] &&
                      payrollexpensepolicydata.fnfpolicy[0].fnfpolicyname
                        ? "btn btn-secondary-sm-blue"
                        : "btn btn-secondary-sm-yellow"
                    }
                    onClick={() => this.getComponent("fnf")}
                  >
                    {payrollexpensepolicydata.fnfpolicy &&
                    payrollexpensepolicydata.fnfpolicy.length > 0 &&
                    payrollexpensepolicydata.fnfpolicy[0] &&
                    payrollexpensepolicydata.fnfpolicy[0].fnfpolicyname
                      ? "Update"
                      : "Assign Now"}
                  </Button>
                </div>
              </div>
            </div>
            <div
              id="anchor4"
              className="inner-wrapper translucent "
              tabIndex="3"
            >
              <p className="normal-drak-secondary t-bold margin-bottom-16">
                Performance management
              </p>
              {performancemanagementdata && (
                <div>
                  <div
                    style={{
                      justifyContent: "space-between",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <IconLabel
                      label="Review Form With Structure"
                      img={Performreviewoutlined}
                      labelClassNames="small-blue ellipsis"
                      iconHeight="16"
                    />
                  </div>
                  <div
                    className="display-flex margin-bottom-24 margin-top-8 data-div-disabled"
                    style={{
                      justifyContent: "space-between",
                      alignItems: "center",
                      border: "none",
                    }}
                  >
                    <p className="small-dark-secondary">
                      Generated Review Form
                    </p>

                    <p className="small-dark-secondary">
                      {performancemanagementdata.totalreviewform}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = () => ({
  // employeeid: state.SaveEmployeeid
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      // SaveEmployeeid,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(DocumentationTabs);
